// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View5_wrapper__2YP__","topRow":"View5_topRow__4VLZG","mainUser":"View5_mainUser__3wpW5","user":"View5_user__1uR8J","bottomRow":"View5_bottomRow__LgehD"};